import * as Sentry from '@sentry/browser';

export default function initSentry() {
    Sentry.init({
        enabled: process.env.NODE_ENV === 'production',
        dsn: 'https://0315c06fbd134be8af424a54041a7040@sentry.io/1353514',
        release: process.env.SENTRY_RELEASE,
    });
}
